import type { CSSProperties } from 'react';
import type { Person } from '../lib/types';
import { Icon } from '../components/Icon';
import { CommentInput, type CommentDraft } from './CommentInput';

interface Props {
  title: string;
  style: CSSProperties;
  /** Changes when the pin is placed somewhere else; the text box takes focus again. */
  focusKey?: string;
  projectId: string;
  people: Person[];
  onSubmit: (draft: CommentDraft) => Promise<void>;
  onCancel: () => void;
}

/** Floating box for writing the revision that goes with a freshly placed pin. */
export function Composer({ title, style, focusKey, projectId, people, onSubmit, onCancel }: Props) {
  return (
    <div className="composer" style={style} role="dialog" aria-label="New revision" onPointerDown={(event) => event.stopPropagation()} onClick={(event) => event.stopPropagation()}>
      <div className="composer-head">
        <span className="row">
          <Icon name="pin" /> {title}
        </span>
        <button type="button" className="icon-btn" aria-label="Discard this pin" onClick={onCancel}>
          <Icon name="x" />
        </button>
      </div>
      <CommentInput projectId={projectId} people={people} placeholder="What should change here?" submitLabel="Post" showCategory autoFocus focusKey={focusKey} hideCancelButton onSubmit={onSubmit} onCancel={onCancel} />
    </div>
  );
}
